import validator from 'validator';
import sanitized from './sanitized';

export default ({ email, t }) => {
  return (
    [
      {
        error: [{ field: 'email', message: t?.('input_email_blank') }],
        test: validator.isEmpty(email)
      },
      {
        error: [{ field: 'email', message: t?.('input_email_invalid') }],
        test: !validator.isEmail(email)
      },
      {
        error: [
          {
            field: 'email',
            message: `${t?.('input_email')} ${t?.(
              'input_string_invalid_characters'
            )}`
          }
        ],
        test: !sanitized(email)
      }
    ].find(({ test }) => test)?.error || []
  );
};
